<template>
	<div>
		<div class="box" @click="onFeedBack">
			<i class="el-icon-edit-outline" style="margin-right: 0.3125rem;"></i>
			<span>{{text}}</span>
		</div>
		<el-drawer title="页面反馈" :visible.sync="show" append-to-body>
			<div class="drawer feed">
				<div :style="{flex:'1','margin-top':'0px'}">
					<el-alert style="margin-bottom: 1.5rem;" title="准确选择问题标签或描述，以便及时处理问题" type="warning" show-icon
						:closable="false">
					</el-alert>
					<el-form ref="ruleForm" label-position="left" label-width="80px" size="small">
						<el-form-item label="反馈页面">{{url}}</el-form-item>
						<el-form-item label="问题标签" prop="type">
							<el-checkbox-group v-model="feed.tag">
								<el-checkbox label="功能异常" name="tag"></el-checkbox>
								<el-checkbox label="显示异常" name="tag"></el-checkbox>
								<el-checkbox label="加载不出来" name="tag"></el-checkbox>
								<el-checkbox label="点击没有反应" name="tag"></el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item label="问题描述" prop="desc">
						    <el-input type="textarea" :rows="5" v-model="feed.desc" maxlength="200" show-word-limit></el-input>
						  </el-form-item>
					</el-form>
				</div>
				<div class="drawer-footer">
					<el-button type="primary">提交反馈</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				feed: {
					tag: [],
					desc: ''
				}
			};
		},
		name: "feedBack",
		props: {
			text: {
				type: String,
				default: "异常反馈"
			},
			url: {
				type: String,
				default: ""
			}
		},
		mounted: function() {

		},
		methods: {
			onFeedBack() {
				this.show = true;
				console.log("订单")
			}
		}
	}
</script>

<style scoped>
	.box {
		color: #576b95;
		font-size: 0.875rem;
		cursor: pointer;
	}

	.feed {
		padding: 0 2.5rem 2.5rem;
		box-sizing: border-box;
	}
	
	.feed >>> .el-form-item__label {
		color: #99a9bf;
	}
</style>
